import * as tantin from './tantinJsBridge'
import * as uniapp from './uniappJsBridge'
import { inUniApp } from './inApp'

const jsbridge = inUniApp ? uniapp : tantin

export function nativeGoLogin() {
  jsbridge.nativeGoLogin()
}

export function nativeGoBack() {
  jsbridge.nativeGoBack()
}

export async function callHandler(data, cb) {
  return await jsbridge.callHandler(data, cb)
}

export function oldCallHandler(data) {
  jsbridge.oldCallHandler(data)
}

export const isAndroid = typeof window !== 'undefined' && (navigator.userAgent.includes('Android') || navigator.userAgent.includes('Adr') || navigator.userAgent.includes('tuling'))

export const isiOS = typeof window !== 'undefined' && !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

export default jsbridge
